module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAPCAYAAAA2yOUNAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAADwAAAACDyk47AAAAqElEQVQoFYXR2w2DIBgFYBEGcJOWhAHaSeoIdoN2FCfRd0JoN+kAEHoOD0YDKg9C+D8OF4X3/hpCeCil3lrrX1NpbYyxF0IMgBMWdBXTtFLKFwpfQCZWoeBKJiBxxvCSUvpg6/t664zO4IKO4AbtwQIRWmtvuMjEMfpngfhuuAQBn2M0xvQbVAM5jR+2PcBaTjoCGZ0Bovzv0C+H5GTRkNQ554aisJr4Aw/AfnUOEFQqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/images/arrow-link-right.png
// module id = TlZS
// module chunks = 0